/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  createWhatsAppTemplate(inboxId, payload) {
    return axios.post(
      `${this.url}/${inboxId}/create_whatsapp_template`,
      payload
    );
  }

  deleteWhatsAppTemplate(inboxId, templateName) {
    return axios.delete(`${this.url}/${inboxId}/destroy_whatsapp_template`, {
      params: { template_name: templateName },
    });
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }

  analyzeCSATTemplateUtility(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template/analyze`, {
      template,
    });
  }

  // ---- WhatsApp QR (Baileys) ----
  createWhatsappBaileys(payload) {
    return axios.post(`${this.url}/create_whatsapp_baileys`, payload);
  }

  regenerateBaileysQr(inboxId) {
    return axios.post(`${this.url}/${inboxId}/baileys/regenerate_qr`);
  }

  requestBaileysPairingCode(inboxId) {
    return axios.post(`${this.url}/${inboxId}/baileys/pairing_code`);
  }

  baileysStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/baileys/status`);
  }
}

export default new Inboxes();
